<template>
  <div class="case-samples px-3">
    <b-row>
      <b-col
        class="d-flex align-items-center"
        cols="auto"
      >
        <span
          qa="case-samples-samples-header-h5"
          class="ap-title ap-title__main"
        >
          {{ $tc('global.sample', 2) }}
        </span>
      </b-col>
      <b-col>
        <div class="text-right d-flex justify-content-md-end align-items-sm-end align-items-center flex-md-row flex-sm-column">
          <div class="d-flex align-items-center mb-sm-2 mb-md-0">
            <div class="switch-btn d-flex align-items-center">
              <small class="mr-2">{{ $t('registry.btn.fixSamplesFields') }}</small>
              <input
                id="toggleSwitchSample"
                v-model="cloneButtonEnabled"
                type="checkbox"
                class="offscreen"
                aria-hidden="true"
                @click="showCloneSampleSidepanel"
                @change="updateCloneToggleState"
              >
              <label
                :qa="`case-samples-clone-switch-label-${cloneButtonEnabled ? cloneButtonEnabled : 'false'}`"
                :qa-value="cloneButtonEnabled ? cloneButtonEnabled : 'false'"
                for="toggleSwitchSample"
                class="switch mb-0 mr-2"
              />
            </div>
            <b-button
              v-tooltip="$t('registry.btn.samplesFieldsList')"
              qa="case-samples-clone-button"
              class="btn__icon btn__icon--primary mx1"
              :disabled="!cloneButtonEnabled"
              @click="toggleCloneSampleSidepanel = true"
            >
              <i
                aria-hidden="true"
                class="far fa-clone"
              />
            </b-button>
          </div>
          <div class="d-flex align-items-center">
            <div
              class="vertical-divider mx-3 d-sm-none d-md-block"
            />
            <b-button
              v-if="$_canCreateSample() || $_canEditSample()"
              v-tooltip="$t('component.samplesModal.title')"
              qa="case-samples-modal-samples-button"
              class="btn__icon btn__icon--primary mx-1"
              :disabled="disabledShowSamplesModalButton"
              @click="showSamplesModal"
            >
              <i
                aria-hidden="true"
                class="far fa-prescription-bottle"
              />
            </b-button>
            <b-button
              v-if="$_canPrintCaseLabels()"
              v-tooltip="$t('registry.btn.printLabelSample')"
              qa="case-samples-print-sample-labels-button"
              class="btn__icon btn__icon--primary mx-1"
              :disabled="!selectedRows.length || !$_canBeCaseLabelsPrinted(caseStudy)"
              @click="$emit('printSampleLabels', selectedRows)"
            >
              <i
                aria-hidden="true"
                class="far fa-ticket-alt"
              />
            </b-button>
            <b-button
              v-tooltip="$tc('global.technique', 2)"
              v-shortkey="['alt', 'a']"
              qa="case-samples-assays-button"
              class="btn__icon btn__icon--primary mx-1"
              :disabled="!casId || !samples.length"
              @shortkey.prevent="showTechniquesModal"
              @click="showTechniquesModal"
            >
              <i
                aria-hidden="true"
                class="fas fa-flask"
              />
            </b-button>
            <b-button
              v-tooltip="$t('component.manualShipment.manualShipment')"
              qa="case-samples-manual-shipment-button"
              class="btn__icon btn__icon--primary mx-1"
              :disabled="showManualShipmentModalButtonDisabled"
              @click="showManualShipmentModal"
            >
              <i
                aria-hidden="true"
                class="far fa-box"
              />
            </b-button>
            <!-- Pending Re-Analysis
            <b-button-->
            <!--              v-tooltip="$t('registry.cases.checkUncheckSamplesAsExtendedOnSlides')"-->
            <!--              qa="case-samples-sample-on-slide-button"-->
            <!--              :disabled="disabledSampleOnSlide"-->
            <!--              class="btn__icon btn__icon&#45;&#45;primary"-->
            <!--              @click="updateSamplesAsSamplesOnSlideOrPhysical()"-->
            <!--            >-->
            <!--              <i-->
            <!--                aria-hidden="true"-->
            <!--                class="icon-porta"-->
            <!--              />-->
            <!--            </b-button>-->
            <vt-loading-button
              v-tooltip="$t('global.delete')"
              qa="case-samples-delete-samples-button"
              class="btn__icon btn__icon--primary mx-1"
              :disabled="$_disabledDeleteSamples(selectedRows)"
              :params="{ promise: deleteSamplesGrid }"
            >
              <i
                aria-hidden="true"
                class="fal fa-trash-alt"
              />
            </vt-loading-button>
            <a
              v-if="isEditMode"
              type="button"
              class="grey-normal ml-1 linkbtn"
            >
              <b-button
                id="pop-muestras"
                qa="case-samples-ellipsis-button"
                class="btn__icon btn__icon--primary px-2"
                variant="primary"
                :disabled="disabledPopoverButton"
              ><i
                class="fas fa-ellipsis-v"
                aria-hidden="true"
              /></b-button>
              <b-popover
                target="pop-muestras"
                placement="bottom"
                triggers="click blur"
              >
                <div class="ap-popover">
                  <ul>
                    <li
                      v-if="canCreateIncidentToSample"
                      v-show="popOption"
                    >
                      <b-button
                        qa="case-samples-add-incident-button"
                        :disabled="!canBeIncidentCreated"
                        @click="showIncidentFormModal"
                      >{{ $t('registry.requestGrid.contextMenu.registerIncident') }}</b-button>
                    </li>
                    <li
                      v-if="canAttachDocument"
                      v-show="popOption"
                    >
                      <b-button
                        qa="case-samples-add-attachment-button"
                        :disabled="!canBeDocumentAttached"
                        @click="showSampleAttachmentModal"
                      >{{ $t('registry.btn.addAttach') }}</b-button></li>
                    <li
                      v-show="popOption"
                    >
                      <b-button
                        qa="case-samples-show-in-global-locator-button"
                        @click="showInGlobalLocator(selectedRows[0].label)"
                      >{{ $t('global.showInGlobalLocator') }}</b-button></li>
                  </ul>
                </div>
              </b-popover>
            </a>
            <div
              v-if="$_canCreateSample()"
              class="d-flex align-items-center ml-4"
            >
              <vt-input
                id="cloneNumber"
                v-model="cloneNumber"
                qa="case-samples-number-to-clone-input"
                type="number"
                class="form-control-sm"
                name="cloneNumber"
                style="width:50px"
                placeholder="1"
                :min="1"
                :max="100"
                :disabled="disabledCloneNumberInput"
              />
              <b-button
                v-shortkey="['ctrl', '+']"
                qa="case-samples-clone-samples-button"
                size="sm"
                :disabled="disabledAddNewRowButton"
                class="btn--primary ml-1"
                @shortkey.prevent="addNewRow(true)"
                @click="addNewRow(true)"
              >
                <i
                  class="fal fa-plus mr-2"
                  aria-hidden="true"
                />{{ $tc('global.sample',1) }}
              </b-button>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row class="samples-grid-container pl-3 pr-3 pb-2 mt-2">
      <b-col class="p-0">
        <div
          v-if="cloneButtonEnabled && toggleCloneSampleSidepanel"
          class="clone-sample-sidepanel ap-sidepanel p-3"
        >
          <div class="title text-center d-flex justify-content-between mb-2">
            <span class="primary-color">{{ $t('registry.btn.fixSamplesFields') }}</span>
            <b-button
              v-shortkey="['shift', 'esc']"
              class="btn__icon btn__icon--primary p-0 pr-0"
              @click="toggleCloneSampleSidepanel = false"
              @shortkey.prevent="toggleCloneSampleSidepanel = false"
            >
              <i
                class="far fa-times"
                aria-hidden="true"
              />
            </b-button>
          </div>
          <div>
            <b-tabs class="vt-tabs">
              <b-tab
                active
              >
                <template slot="title">
                  <div qa="case-samples-fix-samples-tab">
                    {{ $tc('global.sample', 2) }}
                  </div>
                </template>
                <div class="sidepanel-scroll">
                  <ul class="p-3">
                    <li>
                      <div class="d-flex align-items-center">
                        <div class="mr-2">
                          <b-form-checkbox
                            id="checkbox-sample-all"
                            v-model="allFixSamplesChecked"
                            name="checkbox-sample-all"
                            @change="selectAllFixSamples"
                          >
                            <div class="pl-2">
                              <span class="main">{{ $t('registry.btn.fixAll') }}</span>
                            </div>
                          </b-form-checkbox>
                        </div>
                      </div>
                    </li>
                    <li
                      v-for="(sample, index) in samples"
                      :key="index"
                    >
                      <div class="d-flex align-items-center">
                        <div class="mr-2">
                          <b-form-checkbox
                            :id="sample.sampleNumber"
                            v-model="sample.checkedForFix"
                            :name="sample.sampleNumber"
                            @change="saveSamplesSelected"
                          >
                            <div class="pl-2">
                              <span class="label-dark">{{ sample.sampleNumber }}</span>
                            </div>
                          </b-form-checkbox>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </b-tab>
              <b-tab
                :disabled="!selectedSamplesForClone.length"
              >
                <template slot="title">
                  <div qa="case-samples-fix-fields-tab">
                    {{ $tc('registry.btn.fields') }}
                  </div>
                </template>
                <div class="sidepanel-scroll">
                  <ul class="px-3 py-2">
                    <li>
                      <b-form-checkbox
                        v-model="allFixFieldsChecked"
                        @change="selectAllFixFields"
                      >
                        <span class="main pl-2">{{ $t('registry.btn.fixAll') }}</span>
                      </b-form-checkbox>
                    </li>
                    <li
                      v-for="(sampleColumn, index) in columnsForSampleFix"
                      :key="index"
                    >
                      <div class="d-flex align-items-center">
                        <div class="mr-2">
                          <b-form-checkbox
                            :id="sampleColumn.field"
                            v-model="sampleColumn.checked"
                            :name="sampleColumn.field"
                            :qa="`case-samples-${sampleColumn.field}-clone`"
                            @change="saveSamplesFields"
                          >
                            <div class="pl-2">
                              <span v-if="sampleColumn.headerName">{{ sampleColumn.headerName }}</span>
                            </div>
                          </b-form-checkbox>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
        <vt-grid
          qa="case-samples-grid"
          class="registry-sample-grid"
          :grid-options="gridOptions"
          :column-defs="columnsFinal"
          component-code="uicomponent.registry.casesamplesgrid"
          :row-data="samples"
          :framework-components="frameworkComponents"
          :suppress-keyboard-event="backspaceFunction"
          :row-class-rules="rowClassRules"
          @keydown.native="vtGridKeyDown = $event"
        />
      </b-col>
    </b-row>
    <!--Modal Muestras -->
    <samples-update-util ref="samplesUpdateUtil" />
    <modal-wrapper ref="modalSamples">
      <modal-samples
        id="samplesModal"
        :samples-array="samples"
        :case-study="caseStudy"
        :case-type-id="caseTypeId"
        @updateSamples="loadSamples"
        @updateSamplesOnDelete="onUpdateSamplesOnDelete($event)"
        @sampleOnSlideUpdate="onSampleOnSlideUpdate"
      />
    </modal-wrapper>
    <modal-wrapper ref="techniquesModal">
      <assays-view-modal
        v-if="samples.length"
        :cas-id="casId"
        :priority-cas="casPriority"
        @updateSamples="loadSamples"
        @portionsUpdated="onAssaysViewModalPortionsUpdated"
        @subportionsUpdated="onAssaysViewModalSubportionsUpdated"
        @subportionsAdded="onAssaysViewModalSubportionsAdded"
      />
    </modal-wrapper>
    <modal-wrapper ref="addFileModalWrapper">
      <add-file-modal
        id="addFileModal"
        ref="addFileModal"
        :attachment-entity-type="ATTACHMENT_ENTITY_TYPE"
        :entities-id-array="entitiesIdArray"
        @attachmentsAdded="onAttachmentsAdded"
      />
    </modal-wrapper>
    <common-attachment-tree-modal
      v-if="patient"
      ref="attachmentTreeModal"
      :patient="patient"
      :laboratory-id="labId"
      @attachments-updated="loadSamples"
    />
    <modal-wrapper ref="itemsForShippingModal">
      <items-for-shipping-modal
        :samples="elementsToSend"
        :cas-id="casId"
        :lab-id="labId"
      />
    </modal-wrapper>
    <manual-shipment
      ref="manualShipment"
      :samples="selectedSamplesForManualShipment"
    />
  </div>
</template>
<script>
import VtSelectCellEditor from '@/cellEditors/common/VtSelectCellEditor'
import DatePickerRenderer from '@/cellRenderers/registry/DatePickerRenderer'
import gridSideBarConfig from '@/grid/gridSideBarConfig'
import ModalSamples from '@/modules/RegistryModule/views/editCase/modals/ModalSamples'
import AssaysViewModal from '@/components/assays-view/components/modal/assays-view-modal.vue'
import ManualShipment from '@/components/manual-shipment/manual-shipment.vue'
import VtGrid from '@/components/VtGrid/VtGrid'
import buildIconHeaderTemplate from '@/grid/buildIconHeaderTemplate'
import samplesMixin from '@/modules/RegistryModule/views/editCase/mixins/samplesMixin'
import SamplesUpdateUtil from '@/components/common/SamplesUpdateUtil'
import { cloneDeep, pick } from 'lodash'
import AddFileModal from '@/components/AddFileModal'
import registrySampleService from '@/modules/RegistryModule/services/sampleServices'
import CommonAttachmentTreeModal from '@/components/attachments/CommonAttachmentModalTree'
import customConfigResource from '@/api/resources/ui/CustomConfigResource'
import ItemsForShippingModal from '@/modules/shipments-module/old/views/components/ItemsForShippingModal'
import { ModuleOperationGuard } from '@/api/operations/guards/module-operation-guard'
import { ATTACHMENT_ENTITY_TYPE } from '@/api/resources/attachment/attachmentResource'
import { SampleOperationGuardMixin } from '@/api/operations/mixins/guards/sample-operation-guard.mixin'
import { CaseOperationGuardMixin } from '@/api/operations/mixins/guards/case-operation-guard.mixin'
import { ShipmentOperationGuardMixin } from '@/api/operations/mixins/guards/shipment-operation-guard.mixin'
import { IncidentOperationGuardMixin } from '@/api/operations/mixins/guards/incident-operation-guard.mixin'
import { commonSampleClassificationService } from '@/api/resources/common/sample-classification/sample-classification.service'
import { AgGridColumnType, AgGridRowModelType } from '@/shared/models/ag-grid.model'
import VtSelectAsynchronousCellEditor from '@/cellEditors/common/VtSelectAsynchronousCellEditor'
import { ModuleOperation } from '@/api/operations/models/module-operation'
import apiExceptionType from '@/utils/apiExceptionType'

const NEW_CASE_ROUTE_NAME = 'newCase'
const LOAD_CASE_EMIT = 'load-case'
export default {
    name: 'CaseSamples',
    components: {
        ModalSamples,
        AssaysViewModal,
        ManualShipment,
        VtGrid,
        SamplesUpdateUtil,
        AddFileModal,
        CommonAttachmentTreeModal,
        ItemsForShippingModal
    },
    mixins: [
        samplesMixin,
        SampleOperationGuardMixin,
        CaseOperationGuardMixin,
        ShipmentOperationGuardMixin,
        IncidentOperationGuardMixin
    ],
    props: {
        caseStudy: { type: Object },
        caseTypeId: { type: Number },
        patient: { type: Object, required: true },
        tabIndex: { type: Number }
    },
    data() {
        return {
            gridApi: null,
            selectedRows: [],
            elementsToSend: [],
            fixAttributesUiComponent: 'uicomponent.registry.fixsamplegridattributes',
            allFixSamplesChecked: false,
            allFixFieldsChecked: false,
            selectedSamplesForClone: [],
            selectedSampleFields: [],
            vtGridKeyDown: null,
            addRowActive: true,
            initEmptyRow: false,
            sampleGrid: true,
            popOption: true,
            rowClassRules: true,
            cloneNumber: 1,
            showErrors: false,
            sampleId: null,
            initSamIdSelect: null,
            rowGroupPanelShow: null,
            frameworkComponents: null,
            autoGroupColumnDef: null,
            getRowHeight: null,
            detailHeightPortions: null,
            samples: [],
            samplesClone: [],
            toggleCloneSampleSidepanel: false,
            cloneButtonEnabled: false,
            cloneButtonEnabledOnCreated: false,
            columnDefs: [
                {
                    type: 'customCheckbox'
                },
                {
                    headerName: this.$t('registry.sampleGrid.samNumber'),
                    headerTooltip: this.$t('registry.sampleGrid.samNumber'),
                    type: 'text',
                    field: 'sampleNumber',
                    editable: ({ data }) => this.$_canCreateSample() && (this.$_isCaseDraft(data?.status?.code) || !data?.id),
                    cellRenderer: ({ value }) => value ?? '*',
                    headerComponentParams: {
                        template: buildIconHeaderTemplate('far fa-prescription-bottle')
                    },
                    minWidth: 60,
                    flex: 1
                },
                {
                    headerName: this.$t('registry.sampleGrid.portionsCount'),
                    headerTooltip: this.$t('registry.sampleGrid.portionsCount'),
                    type: 'text',
                    field: 'portionsCount',
                    headerComponentParams: {
                        template: buildIconHeaderTemplate('icon-block')
                    },
                    minWidth: 60,
                    flex: 1
                },
                {
                    type: AgGridColumnType.DIACRITICS_INSENSITIVE_TEXT_FOR_CODE_DESCRIPTION_OR_STRING,
                    headerName: `${this.$t('registry.sampleGrid.location')} *`,
                    field: 'topographicCode',
                    editable: ({ data }) => !this.$_disabledTopographicCode(data),
                    cellEditor: 'vtSelectAsynchronousCellEditor',
                    suppressKeyboardEvent: params => this.supressKeyOnCol(params, 13),
                    cellRenderer: ({ value }) => value ? `${value.code} | ${value.description}` : '',
                    cellEditorParams: params => ({
                        optionLoader: () => this.loadTopographicCodes(params.data),
                        customLabel: this.defaultComboCustomLabel,
                        required: true
                    }),
                    cellClass: (params) => (!params.data || !params.data.topographicCode) && this.showErrors ? 'cellUnsaved' : '',
                    flex: 1
                },
                {
                    type: AgGridColumnType.DIACRITICS_INSENSITIVE_TEXT_FOR_CODE_DESCRIPTION_OR_STRING,
                    headerName: `${this.$t('registry.sampleGrid.sampleType')} *`,
                    field: 'sampleType',
                    editable: ({ data }) => !this.$_disabledSampleType(data),
                    cellEditor: 'vtSelectAsynchronousCellEditor',
                    suppressKeyboardEvent: params => this.supressKeyOnCol(params, 13),
                    cellRenderer: ({ value }) => value ? `${value.code} | ${value.description}` : '',
                    cellEditorParams: params => ({
                        optionLoader: () => this.loadSampleTypes(this.caseTypeId, params.data),
                        customLabel: this.defaultComboCustomLabel,
                        required: true
                    }),
                    cellClass: (params) => (!params.data || !params.data.sampleType) && this.showErrors ? 'cellUnsaved' : '',
                    flex: 1
                },
                {
                    type: AgGridColumnType.DIACRITICS_INSENSITIVE_TEXT_FOR_CODE_DESCRIPTION_OR_STRING,
                    headerName: this.$t('registry.sampleGrid.procedure'),
                    field: 'procedure',
                    editable: ({ data }) => !this.$_disabledProcedure(data),
                    cellEditor: 'vtSelectAsynchronousCellEditor',
                    suppressKeyboardEvent: params => this.supressKeyOnCol(params, 13),
                    cellRenderer: ({ value }) => value ? `${value.code} | ${value.description}` : '',
                    cellEditorParams: params => ({
                        optionLoader: () => this.loadProcedures(params.data),
                        customLabel: this.defaultComboCustomLabel
                    }),
                    flex: 1
                },
                {
                    type: AgGridColumnType.DIACRITICS_INSENSITIVE_TEXT_FOR_CODE_DESCRIPTION_OR_STRING,
                    headerName: this.$t('registry.sampleGrid.mostLikelyDiagnosis'),
                    field: 'mostLikelyMorphologicCode',
                    hide: true,
                    editable: ({ data }) => !this.$_disabledMostLikelyMorphologicCode(data),
                    cellEditor: 'vtSelectAsynchronousCellEditor',
                    suppressKeyboardEvent: params => this.supressKeyOnCol(params, 13),
                    cellRenderer: ({ value }) => value ? `${value.code} | ${value.description}` : '',
                    cellEditorParams: params => ({
                        optionLoader: () => this.loadMostLikelyMorphologicCodes(params.data),
                        customLabel: this.defaultComboCustomLabel
                    }),
                    flex: 1
                },
                {
                    type: 'text',
                    headerName: this.$t('registry.sampleGrid.samConservation'),
                    field: 'conservation',
                    hide: false,
                    editable: ({ data }) => !data.id || (this.$_isCaseEditable(this.caseStatus?.code) &&
                        (this.$_canEditSample() || (this.$_canCreateSample() && !data.id))),
                    suppressKeyboardEvent: params => this.supressKeyOnCol(params, 13),
                    flex: 1
                },
                {
                    type: 'text',
                    headerName: this.$t('registry.sampleGrid.observations'),
                    field: 'observations.text',
                    hide: false,
                    editable: ({ data }) => !data.id || (this.$_isCaseEditable(this.caseStatus?.code) &&
                        (this.$_canEditSample() || (this.$_canCreateSample() && !data.id))),
                    suppressKeyboardEvent: params => this.supressKeyOnCol(params, 13),
                    flex: 1
                },
                {
                    type: 'text',
                    headerName: 'N. de fragmentos',
                    field: 'fragments',
                    hide: true,
                    editable: ({ data }) => !data.id || (this.$_isCaseEditable(this.caseStatus?.code) &&
                        (this.$_canEditSample() || (this.$_canCreateSample() && !data.id))),
                    suppressKeyboardEvent: params => this.supressKeyOnCol(params, 13),
                    flex: 1
                },
                {
                    type: 'dateTime',
                    headerName: this.$t('registry.sampleGrid.samDate'),
                    field: 'samplingDate',
                    cellEditor: 'datePickerRenderer',
                    cellEditorParams: () => ({ notAfter: new Date() }),
                    hide: true,
                    editable: ({ data }) => !data.id || (this.$_isCaseEditable(this.caseStatus?.code) &&
                        (this.$_canEditSample() || (this.$_canCreateSample() && !data.id))),
                    minWidth: 170,
                    suppressKeyboardEvent: params => {
                        this.supressKeyOnCol(params, 13)
                        this.supressKeyOnCol(params, 9)
                    },
                    flex: 1
                },
                {
                    type: 'text',
                    headerName: this.$t('registry.sampleGrid.grossingResponsible'),
                    field: 'grossingResponsible',
                    hide: true,
                    cellEditor: 'vtSelectAsynchronousCellEditor',
                    editable: ({ data }) => !this.$_disabledGrossingResponsible(data),
                    suppressKeyboardEvent: params => this.supressKeyOnCol(params, 13),
                    cellRenderer: ({ value }) => value?.fullName ?? '',
                    cellEditorParams: params => ({
                        optionLoader: () => this.getPersonnelResponsible(params.data),
                        label: 'fullName'
                    }),
                    flex: 1
                },
                {
                    type: 'text',
                    headerName: this.$t('registry.sampleGrid.grossingTech'),
                    field: 'grossingTechController',
                    hide: true,
                    cellEditor: 'vtSelectAsynchronousCellEditor',
                    editable: ({ data }) => !this.$_disabledGrossingTechController(data),
                    suppressKeyboardEvent: params => this.supressKeyOnCol(params, 13),
                    cellRenderer: ({ value }) => value?.fullName ?? '',
                    cellEditorParams: params => ({
                        optionLoader: () => this.getPersonnelControllers(params.data),
                        label: 'fullName'
                    }),
                    flex: 1
                },
                {
                    type: 'text',
                    headerName: this.$t('registry.sampleGrid.grossingCoor'),
                    field: 'grossingCoordinator',
                    hide: true,
                    cellEditor: 'vtSelectAsynchronousCellEditor',
                    editable: ({ data }) => !this.$_disabledGrossingCoordinator(data),
                    suppressKeyboardEvent: params => this.supressKeyOnCol(params, 13),
                    cellRenderer: ({ value }) => value?.fullName ?? '',
                    cellEditorParams: params => ({
                        optionLoader: () => this.getPersonnelCoordinators(params.data),
                        label: 'fullName'
                    }),
                    flex: 1
                },
                {
                    type: 'text',
                    headerName: this.$t('registry.sampleGrid.grossingTutor'),
                    field: 'grossingTutor',
                    hide: true,
                    cellEditor: 'vtSelectAsynchronousCellEditor',
                    editable: ({ data }) => !this.$_disabledGrossingTutor(data),
                    suppressKeyboardEvent: params => this.supressKeyOnCol(params, 13),
                    cellRenderer: ({ value }) => value?.fullName ?? '',
                    cellEditorParams: params => ({
                        optionLoader: () => this.getPersonnelTutors(params.data),
                        label: 'fullName'
                    }),
                    flex: 1
                },
                {
                    type: 'text',
                    headerName: this.$t('registry.sampleGrid.specialist'),
                    field: 'specialist',
                    hide: true,
                    cellEditor: 'vtSelectAsynchronousCellEditor',
                    editable: ({ data }) => !this.$_disabledSpecialist(data),
                    suppressKeyboardEvent: params => this.supressKeyOnCol(params, 13),
                    cellRenderer: ({ value }) => value?.fullName ?? '',
                    cellEditorParams: params => ({
                        optionLoader: () => this.getPersonnelCytologyExperts(params.data),
                        label: 'fullName'
                    }),
                    flex: 1
                },
                {
                    type: 'text',
                    headerName: this.$tc('global.laboratory', 1),
                    colId: 'currentLaboratory.labName',
                    field: 'currentLaboratory.labName',
                    exportField: 'currentLaboratory.labName',
                    flex: 1
                },
                // Pending Re-Analysis
                // {
                //     type: 'checkIconRenderer',
                //     exportType: 'boolean',
                //     headerName: this.$tc('global.sampleOnSlide'),
                //     headerTooltip: this.$tc('global.sampleOnSlide'),
                //     colId: 'sampleOnSlide',
                //     field: 'sampleOnSlide',
                //     exportField: 'sampleOnSlide',
                //     headerComponentParams: {
                //         template: buildIconHeaderTemplate('icon-porta')
                //     },
                //     minWidth: 55,
                //     flex: 1
                // },
                {
                    type: 'attachmentCount',
                    headerName: this.$t('registry.sampleGrid.attachments'),
                    headerTooltip: this.$t('registry.sampleGrid.attachments'),
                    field: 'attachmentsCount',
                    minWidth: 55,
                    flex: 1,
                    filter: false,
                    headerComponentParams: {
                        template: buildIconHeaderTemplate('far fa-paperclip')
                    },
                    onCellClicked: (cell) => this.$refs.attachmentTreeModal.showSample(cell.data.id)
                },
                {
                    type: 'incident',
                    headerName: this.$t('grid.hasAlarms'),
                    headerTooltip: this.$t('grid.hasAlarms'),
                    field: 'incidentsCount',
                    onCellClicked: (params) => this.$emit('openIncidentModal', { id: params.data.id }),
                    headerComponentParams: {
                        template: buildIconHeaderTemplate('far fa-exclamation-triangle')
                    },
                    flex: 1,
                    minWidth: 55
                }
            ],
            entitiesIdArray: []
        }
    },
    computed: {
        disabledSampleOnSlide() {
            return !this.$_isCaseDraft(this.caseStatus?.code) || !this.selectedRows.length || this.selectedRows.some(selectedRow => !selectedRow.id)
        },
        disabledShowSamplesModalButton() {
            return !this.casId || !this.$_isCaseEditable(this.caseStatus?.code)
        },
        showManualShipmentModalButtonDisabled() {
            const userHasOperationInAllLabs = this.selectedRows.every(sample =>
                this.$_hasLabOperation(sample.currentLaboratory?.labId, ModuleOperation.MANUAL_SHIPMENT_RULES))
            return !this.selectedRows.length || !userHasOperationInAllLabs
        },
        disabledCloneNumberInput() {
            return this.casId ? !this.$_isCaseEditable(this.caseStatus?.code) || this.$_isCaseInAmendment(this.caseStatus?.code) : false
        },
        visibleContextMenuOptionShowAttachments() {
            return this.selectedRows.length === 1 && this.selectedRows[0].id
        },
        casId() { return this.caseStudy?.casId },
        casPriority() { return this.caseStudy?.priority },
        caseStatus() { return this.caseStudy?.status },

        canCreateIncidentToSample() {
            return this.selectedRows.length === 1
                ? this.$_canCreateIncident()
                : false
        },
        canBeIncidentCreated() {
            return this.selectedRows.length === 1
                ? !!this.selectedRows[0].id && this.$_canBeIncidentCreatedToSample(this.selectedRows[0])
                : false
        },
        canAttachDocument() {
            return this.selectedRows.length === 1
                ? this.$_canAttachDocumentToSample()
                : false
        },
        canBeDocumentAttached() {
            return this.selectedRows.length === 1
                ? this.$_canBeDocumentAttachedToSample(this.selectedRows[0])
                : false
        },
        disabledPopoverButton() {
            return !this.canCreateIncidentToSample && !this.canAttachDocument
        },
        disabledAddNewRowButton() {
            return !this.addRowActive ||
                Number(this.cloneNumber) > 100 ||
                this.disabledCloneNumberInput ||
                this.$_isCaseInAmendment(this.caseStatus?.code)
        },
        ATTACHMENT_ENTITY_TYPE() {
            return ATTACHMENT_ENTITY_TYPE.SAMPLE
        },
        isEditMode() {
            return !!this.casId
        },
        columnsForSampleFix() {
            return this.columnDefs.filter((column) =>
                ![
                    'incidentsCount',
                    'sampleNumber',
                    'attachmentsCount',
                    'portionsCount'
                ].includes(column.field) &&
                column.type !== 'customCheckbox')
        },
        labId() {
            return this.$store.getters.labId
        },
        gridOptions() {
            return {
                onGridReady: this.onGridReady,
                paginationPageSize: 20,
                paginationAutoPageSize: false,
                stopEditingWhenGridLosesFocus: true,
                sideBar: gridSideBarConfig,
                getContextMenuItems: this.getSamplesContextMenu,
                pagination: false,
                rowHeight: 30,
                rowModelType: AgGridRowModelType.CLIENT_SIDE,
                autoGroupColumnDef: {
                    headerName: 'Consoles',
                    pinned: 'left',
                    cellRendererParams: {
                        suppressCount: true
                    }
                },
                onSelectionChanged: this.onSelectionChanged,
                onCellEditingStopped: params => {
                    if (this.vtGridKeyDown && this.vtGridKeyDown.keyCode === 13) {
                        params.api.setFocusedCell(params?.node.rowIndex, params.column.colId)
                    }
                }
            }
        },
        columnsFinal() {
            let columns = this.columnDefs
            if (!this.$store.getters.ontologyParametersConfiguration?.showProcedure) {
                columns = this.columnDefs.filter((item) => item.field !== 'procedure')
            }
            if (!this.$store.getters.ontologyParametersConfiguration?.showMostlikelydiagnosis) {
                columns = this.columnDefs.filter((item) => item.field !== 'mostLikelyMorphologicCode')
            }
            if (this.$_isCaseValidated(this.caseStatus?.code)) {
                columns.forEach(column => { column.editable = false })
            }

            const hasUnauthorizedBillableConceptsColumnField = 'hasUnauthorizedBillableConcepts'
            const hasGridBillingColumn = columns.find(column => column.field === hasUnauthorizedBillableConceptsColumnField)
            if (ModuleOperationGuard.canAccessBilling && !hasGridBillingColumn) {
                columns.push({
                    type: AgGridColumnType.HAS_UNAUTHORIZED_BILLABLE_CONCEPTS,
                    field: hasUnauthorizedBillableConceptsColumnField,
                    flex: 1,
                    minWidth: 55
                })
            }

            return columns
        },
        selectedSamplesForManualShipment() {
            return this.selectedRows.length ? this.selectedRows.map(selectedRow => ({
                caseId: this.casId,
                sampleId: selectedRow.id,
                label: selectedRow.label
            })) : []
        }
    },
    watch: {
        async casId() {
            await this._load()
        },
        samples: {
            handler() {
                if (this.cloneButtonEnabled && this.selectedSampleFields.length && this.selectedSamplesForClone.length) {
                    this.saveSamplesFixedFields()
                }
            },
            deep: true
        },
        tabIndex() {
            if (this.columnApi && this.tabIndex === 1) {
                const allColumnIds = []
                this.columnApi.getAllColumns().forEach((column) => {
                    if (!column.getColDef().cellRendererFramework) {
                        allColumnIds.push(column.getColId())
                    }
                })
                this.columnApi.autoSizeColumns(allColumnIds)
            }
        },
        async cloneButtonEnabled() {
            if (this.cloneButtonEnabled) {
                const customConfigFields = await customConfigResource.get(this.fixAttributesUiComponent)
                if (customConfigFields && customConfigFields.config.fields instanceof Array) {
                    this.selectedSampleFields = customConfigFields.config.fields
                    this.columnDefs.forEach((column) => {
                        if (this.selectedSampleFields.includes(column.field)) {
                            column.checked = true
                        }
                    })
                    this.$forceUpdate()
                }
            }
        }
    },
    async created() {
        await this._load()
    },
    async beforeMount() {
        this.autoGroupColumnDef = { field: 'assayAssaygroupAssayAssName' }
        this.frameworkComponents = {
            vtSelectCellEditor: VtSelectCellEditor,
            datePickerRenderer: DatePickerRenderer,
            vtSelectAsynchronousCellEditor: VtSelectAsynchronousCellEditor
        }
        this.rowGroupPanelShow = 'always'
        this.getRowHeight = 50
        this.rowClassRules = {
            'new-row': params => {
                return !params.data.id
            }
        }
    },
    mounted() {
        if (this.$route.params.samId) {
            this.$nextTick(() => {
                this.selectSample(this.$route.params.samId)
            })
        }
    },
    methods: {
        async changeSampleAsSampleOnSlide(sampleId) {
            let badRequestErrorMessage = null
            let showSampleOnSlideUpdateQuestion = false
            const response = await this.$_toCallUnique(
                registrySampleService.changeSampleAsSampleOnSlide(this.labId, this.casId, sampleId, true),
                error => {
                    showSampleOnSlideUpdateQuestion = error.response.data.code === this.$apiExceptions.BAD_REQUEST
                    badRequestErrorMessage = error.response.data.message
                    if (!showSampleOnSlideUpdateQuestion) {
                        this.$_showErrorModal(error.response.data.message)
                    }
                }
            )
            if (!response && showSampleOnSlideUpdateQuestion) {
                const confirmationModalResponse = await this.$_showConfirmationModal(badRequestErrorMessage)
                if (confirmationModalResponse) {
                    await this.$_toCallUnique(
                        registrySampleService.changeSampleAsSampleOnSlide(this.labId, this.casId, sampleId, false),
                        error => {
                            if (error.response.data.code === apiExceptionType.MORE_THAN_ONE_ASSAY_APPLIED_BY_AUTOMATISMS_TO_A_SAMPLE_ON_SLIDE) {
                                this.$_showWarningModal(error.response.data.message)
                            } else {
                                this.$_showErrorModal(error.response.data.message)
                            }
                        }
                    )
                }
            }
        },
        async onSampleOnSlideUpdate(sampleId) {
            await this.changeSampleAsSampleOnSlide(sampleId)
            await this.loadSamples()
        },
        async updateSamplesAsSamplesOnSlideOrPhysical() {
            for (const sample of this.selectedRows) {
                await this.changeSampleAsSampleOnSlide(sample.id)
            }
            await this.loadSamples()
        },
        showInGlobalLocator(label) {
            this.$eventHub.$emit('show-in-global-locator', label)
        },
        async _load() {
            if (!this.casId) {
                this.samples = []
                this.cloneNumber = 1
                this.cloneButtonEnabled = this.$store.getters['registry/sampleGridFixFieldsToggle']
                this.cloneButtonEnabledOnCreated = this.$store.getters['registry/sampleGridFixFieldsToggle']
            }
            await this.loadSamples()
        },
        onAssaysViewModalPortionsUpdated() {
            this.$emit(LOAD_CASE_EMIT)
        },
        onAssaysViewModalSubportionsUpdated() {
            this.$emit(LOAD_CASE_EMIT)
        },
        onAssaysViewModalSubportionsAdded() {
            this.$emit(LOAD_CASE_EMIT)
        },
        visibleContextMenuOptionAddAttach(sample) {
            return !!sample.id && this.$_canAttachDocumentToSample() && this.$_canBeDocumentAttachedToSample(sample)
        },
        async checkCaseSamplesCompatibility() {
            const compatibleSampleTypes = await this.$_toCallSecure(commonSampleClassificationService.getCommonSampleTypeSampleClassificationsByLaboratory(
                {
                    laboratoryId: this.labId,
                    caseTypeIds: [this.caseTypeId]
                }
            ))
            if (compatibleSampleTypes) {
                let incompatibleSamples = []
                this.samples.forEach(sample => {
                    const compatibleSample = compatibleSampleTypes.find(sampleType => sampleType.id === sample.sampleType.id)
                    if (!compatibleSample) {
                        incompatibleSamples.push(sample)
                    }
                })
                if (incompatibleSamples.length) {
                    const incompatibleSamplesConfirmation = await this.showConfirmationModalGlobal(this.$t('global.modal.case.incompatibleSamples'))
                    if (incompatibleSamplesConfirmation) {
                        this.removeIncompatibleSamples(incompatibleSamples)
                    }
                }
                return !incompatibleSamples.length
            }
        },
        removeIncompatibleSamples(incompatibleSamples) {
            this.samples = this.samples.filter(sample => {
                return incompatibleSamples.find(incompatibleSample => incompatibleSample.sampleType.id !== sample.sampleType.id)
            })
            this.gridApi.refreshCells({ force: true })
        },
        checkToSend(elementsToSend) {
            this.elementsToSend = elementsToSend
            this.$refs.itemsForShippingModal.show()
        },
        onCheckToSend() {
            this.checkToSend(this.selectedRows)
        },
        onSelectionChanged({ api }) {
            this.selectedRows = api.getSelectedRows()
        },
        onUpdateSamplesOnDelete(samples) {
            this.samples = samples
            this.emitLoadSamples()
        },
        selectAllFixSamples() {
            this.$nextTick(() => {
                this.samples.forEach((sample) => {
                    sample.checkedForFix = this.allFixSamplesChecked
                })
                this.$forceUpdate()
                this.selectedSamplesForClone = this.samples.filter((sample) => sample.checkedForFix)
                if (this.selectedSampleFields.length) {
                    this.saveSamplesFixedFields()
                }
            })
        },
        selectAllFixFields() {
            this.$nextTick(() => {
                this.columnDefs.forEach((column) => {
                    column.checked = this.allFixFieldsChecked
                })
                this.$forceUpdate()
                this.selectedSampleFields = this.columnsForSampleFix.flatMap((column) => column.checked ? [column.field] : [])
                if (this.selectedSamplesForClone.length) {
                    this.saveSamplesFixedFields()
                }
            })
        },
        saveSamplesFields() {
            this.$nextTick(() => {
                this.selectedSampleFields = this.columnsForSampleFix.flatMap((column) => column.checked ? [column.field] : [])
                customConfigResource.save(this.fixAttributesUiComponent, { fields: this.selectedSampleFields })
                if (this.selectedSamplesForClone.length) {
                    this.saveSamplesFixedFields()
                }
            })
        },
        saveSamplesSelected() {
            this.$nextTick(() => {
                this.selectedSamplesForClone = this.samples.filter((sample) => sample.checkedForFix)
                if (this.selectedSampleFields.length) {
                    this.saveSamplesFixedFields()
                }
            })
        },
        saveSamplesFixedFields() {
            const finalSamplesToClone = this.selectedSamplesForClone.map((sample) => {
                return pick(sample, this.selectedSampleFields)
            })
            this.$store.commit('registry/updateSampleGridFixFieldsContent', finalSamplesToClone)
        },
        showCloneSampleSidepanel() {
            this.toggleCloneSampleSidepanel = true
        },
        async updateCloneToggleState() {
            this.$nextTick(async () => {
                this.$store.commit('registry/updateSampleGridFixFieldsToggle', this.cloneButtonEnabled)
            })
        },
        selectSample(id) {
            if (this.gridApi) {
                this.$nextTick(() => {
                    this.gridApi.forEachNode((node) => {
                        if (node.data.id === id) {
                            if (node.selected) {
                                this.$_showWarningModal(this.$tc('registry.sampleGrid.error.sampleAlreadySelected'))
                            } else {
                                node.setSelected(true)
                            }
                        }
                    })
                })
            } else {
                this.initSamIdSelect = id
            }
        },
        async loadSamples() {
            if (this.casId) {
                const response =
                    await this.$_toCallSecure(
                        registrySampleService.getSamplesByCaseId(this.labId, this.casId))
                if (response) {
                    this.samples = response
                    if (this.initSamIdSelect) {
                        this.selectSample(this.initSamIdSelect)
                    }
                    this.cloneSamples(this.samples)
                }
            } else {
                if (this.$_canCreateSample()) {
                    await this.addNewRow()
                }
                if (!this.cloneButtonEnabledOnCreated) {
                    this.cloneSamples(this.samples)
                }
                this.cloneButtonEnabledOnCreated = false
            }

            this.emitLoadSamples()
        },
        showSampleAttachmentModal() {
            const samples = this.gridApi.getSelectedRows()
            if (samples.length !== 1) {
                this.showErrorModalGlobal(this.$t('registry.sampleGrid.error.beforeAddingSampleAttachments'))
                return
            } else if (this.hasSampleBeenChanged()) {
                this.showErrorModalGlobal(this.$t('registry.sampleGrid.error.saveChangesBeforeAddingSampleAttachments'))
                return
            }
            this.entitiesIdArray = [this.laboratoryId, this.casId, samples[0].id]
            this.$refs.addFileModalWrapper.show()
        },
        showIncidentFormModal() {
            const samples = this.gridApi.getSelectedRows()
            if (samples.length !== 1) {
                this.showErrorModalGlobal(this.$t('registry.sampleGrid.error.beforeAddingSampleAttachments'))
                return
            } else if (this.hasSampleBeenChanged()) {
                this.showErrorModalGlobal(this.$t('registry.sampleGrid.error.saveChangesBeforeAddingSampleIncidents'))
                return
            }
            this.createSampleIncident(samples[0])
        },
        async onAttachmentsAdded(attachment) {
            await this.loadSamples()
            this.$emit('sample-attachment-added', attachment.entityId)
        },
        backspaceFunction(params) {
            let keyCode = params.event.keyCode
            if (params && keyCode === 8 && !params.editing && params.colDef?.editable) {
                let field = params.colDef.field
                params.node.data[field] = null
                this.gridApi.refreshCells({ force: true })
                return true
            }
        },
        getSamplesContextMenu(params) {
            const menuItems = []
            if (params?.node) {
                /// BATCH OPERATIONS

                const choice = this.selectedRows > 1 ? 2 : 1
                if (this.$_isCaseEditable(this.caseStatus?.code) &&
                    !this.$_disabledDeleteSamples(this.selectedRows)) {
                    menuItems.push({
                        name: this.$tc('registry.cases.deleteSample', choice),
                        action: () => this.deleteSamplesBatch(this.selectedRows)
                    })
                }
                // Pending Re-Analysis
                // if (!this.disabledSampleOnSlide) {
                //     menuItems.push({
                //         name: this.$tc('registry.cases.checkUncheckSamplesAsExtendedOnSlides'),
                //         action: () => this.updateSamplesAsSamplesOnSlideOrPhysical()
                //     })
                // }
                // TODO: Comment for future development
                // if (this.$_canCreateShipmentRequest()) {
                //     menuItems.push({
                //         name: this.$tc('shipments.actions.checkToSend', choice),
                //         action: () => this.checkToSend(this.selectedRows)
                //     })
                // }

                /// NODE OPERATIONS

                if (this.selectedRows.length === 1) {
                    const sample = params?.node.data

                    if (this.canBeIncidentCreated) {
                        menuItems.push({
                            name: this.$tc('registry.sampleGrid.registerIncident'),
                            action: () => this.createSampleIncident(sample)
                        })
                    }
                    if (sample.id) {
                        menuItems.push({
                            name: this.$tc('registry.sampleGrid.viewIncidents'),
                            action: () => this.contextIncidentModal(sample)
                        })
                    }
                    if (this.visibleContextMenuOptionShowAttachments) {
                        menuItems.push({
                            name: this.$tc('laboratory.grid.contextMenu.viewAttach'),
                            action: () => this.showAttachmentModal(sample)
                        })
                    }
                    if (this.visibleContextMenuOptionAddAttach(sample)) {
                        menuItems.push({
                            name: this.$tc('laboratory.grid.contextMenu.addAttach'),
                            action: () => this.showAddFileModal(sample)
                        })
                    }
                    if (sample.id) {
                        menuItems.push({
                            name: this.$tc('global.showInGlobalLocator'),
                            action: () => this.showInGlobalLocator(sample.label)
                        })
                    }
                }
            }
            return menuItems
        },
        createSampleIncident(sample) {
            this.$emit('openIncidentFormModal', { coreEntity: 'SAMPLE', entitiesIds: { casId: this.casId, samId: sample.id } })
        },
        contextIncidentModal(data) {
            this.$emit('openIncidentModal', { id: data.id })
        },
        async deleteSamplesGrid() {
            const samples = this.gridApi.getSelectedRows()
            if (samples.length) {
                await this.deleteSamplesBatch(samples)
            }
        },
        showAddFileModal(params) {
            this.entitiesIdArray = [params.currentLaboratory.labId, this.casId, params.id]
            this.$refs.addFileModalWrapper.show()
        },
        showAttachmentModal(params) {
            this.$nextTick(() => {
                this.$refs.attachmentTreeModal.showSample(params.id)
            })
        },
        supressKeyOnCol(params, keyToSupress) {
            let keyCode = params.event.keyCode
            return params.editing && keyCode === keyToSupress &&
                (params.colDef.cellEditor === 'vtSelectCellEditor' || params.colDef.cellEditor === 'vtSelectAsynchronousCellEditor')
        },
        showSamplesModal() {
            if (this.hasSampleBeenChanged()) {
                this.$_showWarningModal(this.$t('registry.caseSamples.saveSamplesChangesBeforeContinue'))
            } else {
                this.$refs.modalSamples.show()
            }
        },
        onGridReady(event) {
            this.columnApi = event.columnApi
            this.gridApi = event.api
            if (this.initSamIdSelect) {
                this.gridApi.forEachNode((node) => {
                    if (node.data.id === this.initSamIdSelect) {
                        node.setSelected(true)
                    }
                })
            }

            if (this.initEmptyRow) {
                this.gridApi.updateRowData({ add: [] })
            }
        },
        async addNewRow(fromButton = false) {
            if (Number(this.cloneNumber) + this.samples.length > 500) {
                this.$_showErrorModal(this.$tc('registry.sampleGrid.error.sampleAlreadySelected'))
            } else if (Number(this.cloneNumber) <= 100 && !this.disabledAddNewRowButton) {
                this.addRowActive = false
                let difference = []
                const sampleNumberUsed = this.samples.map((item) => {
                    return item.sampleNumber
                })
                const rowsWithFixedData = this.cloneButtonEnabledOnCreated && this.$store.getters['registry/sampleGridFixFieldsContent'].length
                const sampleNumberNumberOfCopies = rowsWithFixedData ? this.$store.getters['registry/sampleGridFixFieldsContent'].length : this.cloneNumber
                if (sampleNumberNumberOfCopies) {
                    const totalFilesNumber = this.gridApi && this.gridApi.getSelectedRows().length ? sampleNumberNumberOfCopies * this.gridApi.getSelectedRows().length : sampleNumberNumberOfCopies
                    const [, response] = this.casId ? await this.toCall(this.getNextSamplesNumber(sampleNumberUsed, totalFilesNumber))
                        : await this.toCall(this.getNextSamplesNumbersNoCase(sampleNumberUsed, totalFilesNumber))
                    difference = response.filter(x => !sampleNumberUsed.includes(x)).concat(sampleNumberUsed.filter(x => !response.includes(x)))
                }
                if (this.gridApi && this.gridApi.getSelectedRows().length) {
                    let selectedRows = cloneDeep(this.gridApi.getSelectedRows())
                    if (this.cloneNumber) {
                        let duplicatedElements = []
                        selectedRows.forEach(row => {
                            duplicatedElements.push(...Array.from(
                                { length: this.cloneNumber },
                                () => (cloneDeep(row))))
                        })
                        selectedRows = duplicatedElements
                    }
                    selectedRows.forEach((row, index) => {
                        row.id = null
                        row.label = null
                        row.sampleNumber = difference[index]
                        row.portionsCount = null
                        row.incidentsCount = null
                        row.attachmentsCount = null
                    })
                    this.gridApi.updateRowData({ add: selectedRows })
                    this.samples.push(...selectedRows)
                } else if (rowsWithFixedData && !fromButton) {
                    const fixedRows = this.$store.getters['registry/sampleGridFixFieldsContent']
                    this.selectedSamplesForClone = fixedRows
                    for (let i = 0; i < fixedRows.length; i++) {
                        this.samples.push({
                            checkedForFix: true,
                            sampleNumber: difference[i],
                            sampleOnSlide: false,
                            observations: { text: '' },
                            ...fixedRows[i]
                        })
                    }
                } else {
                    let emptyRows = []
                    if (this.cloneNumber) {
                        for (let i = 0; i < this.cloneNumber; i++) {
                            // TODO: user should be able to change sampleOnSlide
                            emptyRows.push({
                                sampleNumber: difference[i],
                                sampleOnSlide: false,
                                observations: { text: '' } })
                        }
                    } else {
                        emptyRows.push({})
                    }
                    if (this.gridApi) {
                        this.gridApi.updateRowData({ add: emptyRows })
                    } else {
                        this.initEmptyRow = true
                    }
                    this.samples.push(...emptyRows)
                }

                this.selectedRows = []
                this.addRowActive = true
                this.emitLoadSamples()
            }
        },
        showTechniquesModal() {
            if (this.tabIndex === 1) {
                let samplesToFocus = this.gridApi.getSelectedRows()
                if (samplesToFocus.length) {
                    samplesToFocus =
                        samplesToFocus.map((sample) => ({
                            label: sample.label
                        }))
                }
                this.$refs.techniquesModal.show([samplesToFocus])
            }
        },
        showManualShipmentModal() {
            this.$refs.manualShipment.show()
        },
        async resetData() {
            if (!this.cloneButtonEnabled) {
                this.samples = []
                await this.addNewRow()
            }
            this.cloneSamples(this.samples)
        }
    }
}
</script>

<style lang="scss">
.clone-sample-sidepanel {
    position: absolute;
    width: 300px;
    height: 100%;
    background: #FFF;
    z-index: 1;
    right: 0;
    box-shadow: -5px 0 5px -5px #b2b2b2;
    border: 1px solid vt-color(grid-general-border);
    .custom-checkbox {
        margin: 0.25rem 0;
    }
}

.clone-sample-sidepanel ul li {
    list-style: none;
    color: vt-color(dark-text);
}

.case-samples .sidepanel-scroll {
    height: calc(100vh - 470px);
    overflow-y: auto;
}

.clone-sample-sidepanel .title {
    color: vt-color(primary);
}

.cellUnsaved {
  border-radius: 3px !important;
  -webkit-box-shadow:inset 0 0 0 1px #fc6274 !important;
    -moz-box-shadow:inset 0 0 0 1px #fc6274 !important;
    box-shadow:inset 0 0 0 1px #fc6274 !important;
    color: #fc6274 !important;
}

.ag-theme-balham .ag-row.new-row{
  border-color: #bffacc !important;
}

.new-row .ag-cell{
  border-left: 1px solid #bffacc !important;
}

.new-row .ag-cell-focus{
  border: 1px solid #0091ea !important;
}

.case-samples .ag-layout-normal{
  padding: 0;
}

.case-samples .clone-sample-sidepanel .nav-tabs {
    justify-content: center;
}

.case-samples .clone-sample-sidepanel .nav-item {
    flex: 1;
}

.case-samples .clone-sample-sidepanel .nav-link {
    text-align: center;
}
.case-samples .registry-sample-grid .multiselect__content-wrapper {
    max-height: 200px !important;
}

</style>

<style lang="scss" scoped>
.switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 20px;
    background-color: rgba(0, 0, 0, 0.25);
    border-radius: 20px;
    transition: all 0.3s;
}

.switch::after {
    content: '';
    position: absolute;
    width: 18px;
    height: 18px;
    border-radius: 18px;
    background-color: white;
    top: 1px;
    left: 1px;
    transition: all 0.3s;
}

input[type='checkbox']:checked + .switch::after {
    transform: translateX(20px);
}

input[type='checkbox']:checked + .switch {
    background-color: vt-color(primary);
}

.offscreen {
    position: absolute;
    left: -9999px;
}

.separator {
  font-size: 1.3rem;
}
.registry-sample-grid {
  height: calc(100vh - 370px);
}

@media (max-width: 1370px) {
  .registry-sample-grid {
  height: calc(100vh - 370px);
}

.case-samples .sidepanel-scroll {
    height: calc(100vh - 470px);
}

}

</style>
